<template>
  <section class="workcenter-column workcenter-column--parts">
    <header class="workcenter-column__header workcenter-column__header--parts">
      <strong>Parts Tracker</strong>
      <i class="bx bx-dots-horizontal-rounded"></i>
    </header>
    <div class="workcenter-column__tabs">
      <button type="button" class="workcenter-column__tab workcenter-column__tab--parts-active">Notifications <span class="workcenter-column__count workcenter-column__count--parts">0</span></button>
      <button type="button" class="workcenter-column__tab">Arriving <span class="workcenter-column__count">0</span></button>
    </div>
    <div class="workcenter-column__search">
      <input type="text" placeholder="Search here">
      <i class="bx bx-search"></i>
    </div>
    <div class="workcenter-column__tray">
      <workcenter-card
        v-for="part in parts"
        :key="part.id"
        :item="part"
        :title="part.title"
        :message="part.message"
        :date-label="part.date"
        :job-number="part.supplier"
        :tag="part.tag"
        :tag-color="part.color"
        icon="bx bx-package"
        :unread="part.unread"
        @contextmenu="$emit('contextmenu', $event, part, 'part')"
      />
    </div>
  </section>
</template>

<script>
import WorkcenterCard from './workcenter-card'

export default {
  name: 'PartsTracker',
  components: { WorkcenterCard },
  data() {
    return {
      parts: [
        // { id: 'part-1', title: 'PO-8821 / RO-8832', supplier: 'Sydney Auto Parts', tag: 'ETA Update', color: 'blue', message: 'Delivery brought forward to 12-May', date: '14-May 09:15am', unread: true },
        // { id: 'part-2', title: 'PO-9104 / RO-9104', supplier: 'Pert Warren', tag: 'Backorder', color: 'orange', message: 'Part on national backorder. No ETA.', date: '13-May 11:20am', unread: true },
        // { id: 'part-3', title: 'PO-8755 / RO-8755', supplier: 'Westend Mazda', tag: 'Cancelled', color: 'grey', message: 'Order cancelled by supplier.', date: '12-May 08:00am', unread: false }
      ]
    }
  }
}
</script>
